// extracted by mini-css-extract-plugin
var _1 = "qr763";
export { _1 as "translatedError" }
